import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Modal from 'components/common/Modal'
import Text from 'components/common/Text/Text'
import ProvidePhoneNumberForm from './components/ProvidePhoneNumberForm'

const ProvidePhoneNumberModal = ({
  closeProvidePhoneNumberModal,
  instruction,
  submitPhoneNumber,
  ...props
}) =>
  <ModalBox title="Provide Phone Number" closeHandler={ closeProvidePhoneNumberModal }>
    <Instructions block data-at-instructions>
      { instruction }
    </Instructions>
    <ProvidePhoneNumberForm
      onSubmit={ submitPhoneNumber }
      onCancel={ closeProvidePhoneNumberModal }
      { ...props } />
  </ModalBox>

export default ProvidePhoneNumberModal

ProvidePhoneNumberModal.propTypes = {
  closeProvidePhoneNumberModal: PropTypes.func,
  hideProvidedNumberPhoneModal: PropTypes.func,
  instruction: PropTypes.string,
  submitPhoneNumber: PropTypes.func
}

const Instructions = styled(Text)`
  margin-bottom: 26px;
`

const ModalBox = styled(Modal)`
  padding: 25px 24px 67px;
`
